module.exports = __webpack_public_path__ + "components/MapControl/svg/Pomnik przyrody ożywionej.svg?4621dcd1";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Pomnik przyrody ożywionej.svg
// module id = 2080
// module chunks = 0